<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" :width="width" :height="height" viewBox="0 0 445 350">
        <path stroke="#432026" d="M88.727.5h267.547c5.845 0 11.337 2.78 14.775 7.478l71.752 98.052.376-.276-.376.276a8.783 8.783 0 0 1-.655 11.176L229.029 346.659c-3.328 3.583-8.949 3.808-12.555.5a9.547 9.547 0 0 1-.505-.501L2.855 117.206A8.782 8.782 0 0 1 2.2 106.03L73.95 7.978A18.306 18.306 0 0 1 88.727.5Z"></path>
        <path :stroke="`url(#${gradientId})`" stroke-opacity=".2" d="M88.727.5h267.547c5.845 0 11.337 2.78 14.775 7.478l71.752 98.052.376-.276-.376.276a8.783 8.783 0 0 1-.655 11.176L229.029 346.659c-3.328 3.583-8.949 3.808-12.555.5a9.547 9.547 0 0 1-.505-.501L2.855 117.206A8.782 8.782 0 0 1 2.2 106.03L73.95 7.978A18.306 18.306 0 0 1 88.727.5Z"></path>
        <defs>
            <linearGradient :id="gradientId" x1="222.5" x2="222.5" y1="0" y2="350" gradientUnits="userSpaceOnUse">
                <stop stop-color="#fff"></stop>
                <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: '445',
        },
        height: {
            type: String,
            default: '350',
        },
    },
    computed: {
        gradientId() {
            return `gem-outline-gradient-${this._uid}`;
        },
    },
}
</script>
